module.exports = __webpack_public_path__ + "static/media/10.b57e4131.png";